import { v4 as uuidv4 } from 'uuid';
import logger from '../globalHandler/logging';
import {loggingConfig} from '../globalHandler/logger-config.js';

const maxInactivityTime = 600000; //10 minutes in milliseconds

const setActivityDateTimeToNow = async () => {
  if (typeof Storage !== 'undefined') {
    localStorage.setItem('lastActivityTime', JSON.stringify(Date.now()));
  }
};

const logOutRequired = async (auth) => {
  // Check if a user is authenticated - if not authenticated, no need to logout
  if(auth !==null && typeof(auth)!='undefined'){
    let isAuthenticated = await auth.isAuthenticated()
    if(!isAuthenticated){
      return false;
    }
  }

  if (typeof Storage !== 'undefined') {
    // A valid UI session should have the Session Cookies set
    // Those are setup by by the OKTA handler on Implicit/callback during login
    // only the closing browser can delete those. If it is the case then user should re-login
    let cookieSession = getCookie('okta-oauth-state');
    let cookieNonce = getCookie('okta-oauth-nonce');
    if (cookieNonce === null || cookieSession === null) {
      // TODO - would be even better if we could validate if those cookies are real???
      // I cannot see anything on API...
      return false;
    }

    let datetime = JSON.parse(localStorage.getItem('lastActivityTime'));
    if (datetime == null) {
      return false;
    }

    let lastActivityParsed = parseInt(datetime);
    if (isNaN(lastActivityParsed)) {
      return false;
    }

  // In case someone temper with the Last Activity Datetime - tried to hack to setup the timeout to set in the future
  // The last activity datetime cannot be > Now
    if(isLastActivityInFuture(lastActivityParsed)){
      return true;
    }

    let inactivityTime = Date.now() - lastActivityParsed;
    if (inactivityTime > maxInactivityTime) {
      // Timeout already passed
      return true;
    }

    // continue tracking
    return false;
  }
};

const isLastActivityInFuture = (lastActivityParsed) =>{
  // In case someone temper with the Last Activity Datetime - tried to hack to setup the timeout to set in the future
  // The last activity datetime cannot be > Now
  if(lastActivityParsed > Date.now()){
    return true;
  }
  return false
}

const getCookie = (cname) => {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
};

const setSessionCookie = (cname, cvalue) => {
  const expires = "expires=";
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// remove Cookie - set expirey date and value to nothing...
const removeCookie = (cname) => {
  document.cookie = cname + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
};

// Return true when Logout is required
const setActivityAndLogout = async () => {
  // Before setting up the variable in session state - we want to ensure the session did not timed out - if it did then log the user out.
  let datetime = JSON.parse(localStorage.getItem('lastActivityTime'));
  if (datetime == null) {
    await setActivityDatesetActivityDateTimeToNowTime();
    return false;
  }

  let lastActivityParsed = parseInt(datetime);
  if (isNaN(lastActivityParsed)) {
    await setActivityDateTimeToNow();
    return false;
  }

  // In case someone temper with the Last Activity Datetime - tried to hack to setup the timeout to set in the future
  // The last activity datetime cannot be > Now
  if(isLastActivityInFuture(lastActivityParsed)){
    return true;
  }

  let inactivityTime = Date.now() - lastActivityParsed;
  if (inactivityTime > maxInactivityTime) {
    return true;
  } else {
    await setActivityDateTimeToNow();
    return false;
  }
};

const setLocalStorageCorrelationId = (id, log) => {
  try{
    // Generate a random GUID and concat the id from parameter
    let investorId = '';
    if(id!==null){
      investorId = id;
    }
    const trackingId = uuidv4() + '_' + investorId;

    // set a local storage var with it so we can retrieve this from different tabs
    if (typeof Storage !== 'undefined') {
      setSessionCookie('X-Correlation-ID', JSON.stringify(trackingId));
    }
    return trackingId;
  }
  catch(e){
    // TODO - LOG the error somewhere
    if(id!==null && typeof(id) !=='undefined'){
      if(log){
        log.error('Could not save the x-correlation-ID on UI for user ' + id + ' - Inner exception:', e);
      }
    }
    else{
      if(log){
        log.error('Could not save the x-correlation-ID on UI for undefined id - Inner exception:', e);
      }
    }
  }
  return null;
};

const updateLocalStorageCorrelationId = (id,log) => {
  try{
    // Get potential existing ID
    if (typeof Storage !== 'undefined') {
      let trackingId = JSON.parse(getCookie('X-Correlation-ID'));
      if(trackingId === null){
        throw 'trying to update a session on UI - but session is not started - user ID: '+ id;
      }

      // Gets the GUID - this is unique for the session
      let parts = trackingId.split('_');
      let investorId = '';
      if(id!==null){
        investorId = id;
      }
      const newTrackingId = parts[0] + '_' + investorId;

      // set a local storage var with it so we can retrieve this from different tabs
      setSessionCookie('X-Correlation-ID', JSON.stringify(newTrackingId));
      return newTrackingId;
    }
  }
  catch(e){
    // TODO - LOG the error somewhere
    if(id!==null && typeof(id) !=='undefined'){
      if(log){
        log.error('Could not save the x-correlation-ID on UI for user ' + id + ' - Inner exception:', e);
      }
    }
    else{
      if(log){
        log.error('Could not save the x-correlation-ID on UI for undefined ID - Inner exception:', e);
      }
    }
  }
  return null;
};

const setCorrelationId = async (auth, config) => {
  // Initiate Logger
  const log = new logger(loggingConfig, config.appInsightId);
  if (typeof Storage === 'undefined') {
    return null;
  }
  // Get potential existing ID
  let trackingId = JSON.parse(getCookie('X-Correlation-ID'));

  // Get user ID
  let userID = null;
  if (auth && typeof(auth) !=='undefined' && await auth.isAuthenticated() && auth.userDetails) {
    userID = auth.userDetails.customerId;
  }

  // Brand new session need to generate a new GUID
  if(trackingId == null){
    return setLocalStorageCorrelationId(userID, log);
  }

  // If UI session timedOut - set a new ID 
  if(await logOutRequired(auth)){
    return setLocalStorageCorrelationId(null, log);
  }

  // get userID from the session ID to ensure it matches
  let parts = trackingId.split('_');
  let sessionUserId = null;
  if(parts.length === 2){
    sessionUserId = parts[1];
  }

  // If user just logged in then sessionUserId was null and now user is authenticated => update the session
  if(sessionUserId === null || sessionUserId === ''){
    return updateLocalStorageCorrelationId(userID, log);
  }

  // SessionUserId !=null 
  // If the IDs on the session exists but user got logged out => restart new session...
  if(userID ==null ){
    return setLocalStorageCorrelationId(null, log);
  }

  // If the User IDs do not match... This should not be possible though
  if(userID !== sessionUserId){
    const newSessionTracking =  setLocalStorageCorrelationId(userID, log);
    if(log){
      log.warning('User logged in and Session user are different: user_id: '+ userID + ' but sessionUserId: '+ sessionUserId + ' | new session started: +' + newSessionTracking);
    }
    // Should we throw and exception instead...
    return newSessionTracking;
  }

  // Session Tracking is up to date. Just return it...
  return trackingId;
};

const removeCorrelationId = () =>{
  removeCookie('X-Correlation-ID');
};

const getCorrelationId = () =>{
  if (typeof Storage === 'undefined') {
    return null;
  }
  // Get potential existing ID
  return JSON.parse(getCookie('X-Correlation-ID'));
}


export {
  setActivityAndLogout,
  setActivityDateTimeToNow,
  logOutRequired,
  setCorrelationId,
  getCorrelationId,
  removeCorrelationId
};
